/**
 * Класс исчезающего слайдера
 */

/** Класс активного слайда */
const CLASS_CURRENT: string = 'current';

class FadeSlideshow
{
	/** Контейнер со слайдшоу */
	private slideshow: HTMLElement;
	/** Индекс слайда */
	private index: number;
	/** Коллекция слайдов */
	private slidesCollection: NodeListOf<HTMLLIElement>;
	/** Текущий индекс */
	private currentIndex: number;
	/** Кнопка назад */
	private buttonPrev: HTMLButtonElement;
	/** Кнопка вперёд */
	private buttonNext: HTMLButtonElement;
	
	constructor( slideshow: HTMLElement, index: number = 0 )
	{
		this.slideshow = slideshow;
		this.index = index;
		this.slidesCollection = slideshow.querySelectorAll( 'li' ) as NodeListOf<HTMLLIElement>;
		this.currentIndex = this.index;
		this.buttonPrev = slideshow.querySelector( 'button.prev' ) as HTMLButtonElement;
		this.buttonNext = slideshow.querySelector( 'button.next' ) as HTMLButtonElement;

		this.slidesCollection[this.currentIndex].classList.add( CLASS_CURRENT );
		
		if ( this.slidesCollection.length <= 1 )
		{
			return;
		}
		
		this.registerHandlers();
	}
	
	// Регистрация обработчиков
	private registerHandlers(): void
	{
		this.buttonPrev.addEventListener( 'click', () => this.prev() );
		this.buttonNext.addEventListener( 'click', () => this.next() );
	}
	// Предыдущий слайд
	private prev(): void
	{
		this.slidesCollection[this.currentIndex].classList.remove( CLASS_CURRENT );
		this.currentIndex--;
		
		if ( this.currentIndex < 0 )
		{
			this.currentIndex = this.slidesCollection.length - 1;
		}
		
		this.slidesCollection[this.currentIndex].classList.add( CLASS_CURRENT );
	}
	// Следующий слайд
	private next(): void
	{
		this.slidesCollection[this.currentIndex].classList.remove( CLASS_CURRENT );
		this.currentIndex++;
		
		if ( this.currentIndex >= this.slidesCollection.length )
		{
			this.currentIndex = 0;
		}
		
		this.slidesCollection[this.currentIndex].classList.add( CLASS_CURRENT );
	}
}

export {
	FadeSlideshow as default,
}